export default "__VITE_ASSET__DDMwbHea__"